import React from 'react'
// Loads react & flex form and bootstraps them on page load & turbo frame load
async function initFlexForms(event) {
  let elements = document.querySelectorAll('flex-form')
  if (elements.length > 0) {
    const ReactDOM = await import('react-dom/client')
    const flexForm = await import('flex-form')

    elements.forEach((element) => {
      const endOfFlowBehaviour = element.getAttribute('end-of-flow-behavior') || 'end';

      let Root = () => {
        return (
          <flexForm.default
            flowId={element.getAttribute('flow-id')}
            flowData={JSON.parse(element.getAttribute('flow-data'))}
            endOfFlowBehaviour={endOfFlowBehaviour}
            lang={element.getAttribute('lang')}
          />
        )
      }

      ReactDOM.createRoot(element).render(<Root />)
    })
  }
}

document.documentElement.addEventListener('turbo:load', initFlexForms)
document.documentElement.addEventListener('turbo:frame-render', initFlexForms)